module.exports = __webpack_public_path__ + "static/media/waiting-room.49611703.svg";